import { createSelector } from 'reselect';

export const getAssetType = (state) => state.global.assetType;

export const getAssetName = createSelector(
  getAssetType,
  ({ appContext }) => {
    switch (appContext) {
      case 'tray':
        return 'Trays';
      case 'pallet':
        return 'Pallet Boxes';
      case 'bag':
        return 'Bags';
      default:
        return appContext;
    }
  },
);
